module.exports = __webpack_public_path__ + "static/media/Shield-dark.b6ea6897.svg";